import { render, staticRenderFns } from "./SupportSection.vue?vue&type=template&id=4fd02b78&scoped=true&"
import script from "./SupportSection.vue?vue&type=script&lang=ts&"
export * from "./SupportSection.vue?vue&type=script&lang=ts&"
import style0 from "./SupportSection.vue?vue&type=style&index=0&id=4fd02b78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd02b78",
  null
  
)

export default component.exports